import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import { IconButton, useMediaQuery } from "@mui/material";
import { Close } from "@mui/icons-material";
export default function SkModal({
  children,
  show,
  unShow,
  width,
  height,
  overflowY,
  padding,
  maxHeight,
}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const isMobile = useMediaQuery("(max-width:870px)");

  return (
    <div>
      <Modal
        open={show}
        onClose={() => unShow(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 1, sm: 2 },
        }}
      >
        <Box
          sx={({ palette: { dark, white } }) => ({
            backgroundColor: darkMode ? dark.main : white.main,
            position: "relative",
            width: isMobile ? "95%" : width ? width : 600,
            maxWidth: "96vw",
            height: height ? height : "auto",
            maxHeight: maxHeight ? maxHeight : "90vh",
            borderRadius: 3,
            boxShadow: 24,
            outline: "none",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          })}
        >
          <IconButton
            onClick={() => {
              unShow(false);
            }}
            sx={({ palette: { error } }) => ({
              color: error.main,
              position: "absolute",
              top: 12,
              right: 12,
              border: 1,
              borderRadius: 2,
              p: 0.5,
              borderColor: error.main,
              zIndex: 1300,
              backgroundColor: darkMode ? "rgba(0,0,0,0.3)" : "rgba(255,255,255,0.9)",
              "&:hover": {
                backgroundColor: darkMode ? "rgba(0,0,0,0.6)" : "rgba(240,240,240,1)",
              },
            })}
          >
            <Close sx={{ fontSize: 20 }} />
          </IconButton>
          <Box
            sx={{
              backgroundColor: "transparent",
              width: "100%",
              height: "100%",
              maxHeight: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              p: padding !== undefined ? padding : { xs: 2, sm: 3, md: 4 },
              boxSizing: "border-box",
              scrollBehavior: "smooth",
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: darkMode ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: darkMode ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)",
              },
            }}
          >
            {children}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
SkModal.propTypes = {
  children: PropTypes.node,
  overflowY: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  unShow: PropTypes.func.isRequired,
  width: PropTypes.any,
  height: PropTypes.any,
  padding: PropTypes.any,
  maxHeight: PropTypes.string,
};
